<template>
  <div class="personalProdures">
    <div class="right_produre_btn_wrap">
      <span @click="addNewGroup($event)">新建分组</span>
      <span @click="addNewProdure($event)">新建话术</span>
    </div>
    <div v-if="datalist.length > 0" class="tree-child">
      <div v-for="(item, index) in resetDataList" :key="item.id" ref="produreItem" class="personalProdureItem" :class="item.topFlag === 1 ? 'toTopSpace' : ''">
        <div class="first-child flex-center" @click="expandItem(item.id)" :class="activeNames == item.id ? 'bordernone' : ''">
          <van-icon class="expandIcon" :name="activeNames == item.id ? require('../assets/images/replydown.png') : require('../assets/images/replyopen.png')" />
          <p class="tree-title">{{ item.title }}</p>
        </div>

        <div class="position_group_border" v-if="activeIndex === index" ref="border">
          <span @click="moveToUp(index, $event)" v-if="!item.topFlag && index !== 0 && item.id !== list[0].id">上移</span>
          <span @click="moveToBottom(index, $event)" v-if="index + 1 !== resetDataList.length && !item.topFlag">下移</span>
          <span @click="resetTop(index, item, $event)">{{ item.topFlag ? "取消置顶" : "置顶" }}</span>
          <span @click="addNewGroup($event, item)">重命名</span>
          <span @click="deleteProdure(item.id, 'group', index, $event)">删除分组</span>
        </div>

        <div class="circle_click" @click="produre_group(index, $event)">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <!--       </template>-->
        <div v-if="treeList.length > 0 && activeNames === item.id">
          <div v-for="(two, i) in treeList" :key="two.id" class="tree-contnt" ref="produre_list">
            <div class="circle_click" @click="clickProdureItem(i, $event)">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="position_group_border" v-if="listIndex === i" ref="produre_item">
              <span @click="editProdureItem(two, $event)">编辑</span>
              <span @click="moveToUp(i, $event)" v-if="i !== 0">上移</span>
              <span @click="moveToBottom(i, $event)" v-if="i + 1 !== treeList.length">下移</span>
              <span @click="moveItemTo(two.id)">移动至</span>
              <span @click="deleteProdure(two.id, 'list', i, $event)">删除话术</span>
            </div>

            <h4 class="flex-center">
              <van-icon class="tree-two-icon" :name="require('../assets/images/sendchoose.png')" />
              {{ two.title }}
            </h4>

            <div v-for="third in two.newlistArr" :key="third.id" class="tree-third">
              <div @click="shareList(third)" class="flex-center">
                <van-icon class="tree-third-icon" :name="require('../assets/images/sendnormal.png')" />
                <div class="tree-rig-flex">
                  <div class="third-img" style="display: flex">
                    <div class="flex-left">
                      <img v-lazy="third.url" v-show="third.url && third.msgType == 'image' && third.url !== ''" alt="" />
                      <img v-show="third.picUrl && third.msgType == 'link' && third.picUrl !== ''" alt="" v-lazy="third.picUrl" />
                      <img v-show="third.url && third.msgType == 'miniprogram' && third.url !== ''" alt="" v-lazy="third.url" />
                      <img v-show="third.msgType == 'link' && third.picUrl == ''" alt="" v-lazy="require('../assets/images/website.png')" />
                      <img v-show="third.msgType == 'file'" alt="" v-lazy="require('../assets/images/text.png')" />
                      <img v-show="third.msgType == 'video'" alt="" v-lazy="require('../assets/images/video.png')" />

                      <img v-show="third.msgType == 'text'" alt="" v-lazy="require('../assets/images/text.png')" />

                      <img v-show="third.msgType == 'miniprogram' && third.url === ''" alt="" v-lazy="require('../assets/images/mini.png')" />
                      <img v-show="third.msgType == 'image' && third.url == ''" alt="" v-lazy="require('../assets/images/img.png')" />
                    </div>

                    <div class="third-right">
                      <div v-if="third.msgType == 'text'" class="textMsgType">
                        <p ref="filename">
                          {{ third.content }}
                        </p>
                        <span @click="handleShowMoreClick()" class="blue-color">{{ showMore ? "收起" : "展开" }}</span>
                      </div>
                      <div v-else class="third-size">
                        <p>
                          {{ third.fileName }}
                        </p>
                        {{ third.size || 0 }}kb
                      </div>
                    </div>
                  </div>
                  <span
                    v-if="['image', 'video'].indexOf(third.msgType) > -1 || (third.msgType == 'file' && third.fileName.slice(third.fileName.lastIndexOf('.') - 1 + 2) == 'pdf')"
                    @click="previewFile($event, third)"
                    class="review-btn"
                    >预览</span
                  >
                </div>
              </div>
            </div>

            <div v-if="two.listtotal > 3">
              <p v-if="!expandTrue" @click="lookMore(two)" class="max-look">查看更多 <van-icon name="arrow-down"></van-icon></p>
              <p v-if="expandTrue" @click="closeList(two)" class="max-look">收起 <van-icon name="arrow-up"></van-icon></p>
            </div>
          </div>
        </div>
        <div v-else-if="activeNames == item.id && treeList.length == 0" class="empty_produre">
          <span>暂无话术</span>
        </div>
      </div>
    </div>
    <!--添加分组-->
    <van-dialog
      v-model="groupDialog"
      :title="groupType"
      show-cancel-button
      confirm-button-color="#277FFF"
      :before-close="beforeClose"
      @confirm="addNewGroupConfirm"
      @cancel="addNewGroupCancel"
    >
      <van-form ref="addNewGroup">
        <van-field type="text" maxlength="16" show-word-limit v-model="addGroupName" placeholder="请输入分组名称" class="addNewGroup" />
        <p class="error_warn" v-show="showError">请输入分组名称</p>
      </van-form>
    </van-dialog>

    <!--    分组下拉-->
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="resetDataList"
        :default-index="defaultIndex"
        @confirm="onConfirm"
        class="selectGroup"
        @cancel="
          showPicker = false;
          listIndex = 99999;
        "
      >
        <template #option="option">
          <span>{{ option.title }}</span>
        </template>
      </van-picker>
    </van-popup>

    <!-- 预览pdf -->
    <van-popup v-model="showPdf" position="bottom" closeable round class="popup-pdf" @closed="closePopup">
      <div class="detail-popup">
        <div id="pdf-detail"></div>
      </div>
    </van-popup>
    <!-- 预览图片，视频 -->
    <van-dialog v-model="showFile" :showConfirmButton="false" :closeOnClickOverlay="true" width="90%" class="preview-img" @close="closeImg">
      <!-- :class="{ videoDialog: showType == 'video' }" -->
      <img v-if="showType == 'image'" :src="preFileUrl" />
      <video v-if="showType == 'video'" :autoplay="false" :src="preFileUrl" controls />
      <div class="btn">
        <span @click="shareList(detailObj)">
          <van-icon name="share" />
          分享</span
        >
        <span @click="closeImg">关闭</span>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import personalTree from "./js/personalTree";
export default personalTree;
</script>
<style lang="less" scoped>
@import "css/personalProdure";
</style>
